export const slotGamesDevelopmentProcessTextContent = {
  headingText: "Slot Game Development Process",
  content: [
    {
      iconSrc: "/assets/stock-img/slot_game_development_process_img_01.webp",
      titleText: "Slot Business Ideation",
    },
    {
      iconSrc: "/assets/stock-img/slot_game_development_process_img_02.webp",
      titleText: "Conceptualization & Planning",
    },
    {
      iconSrc: "/assets/stock-img/slot_game_development_process_img_03.webp",
      titleText: "Wireframing, Sketching & Art",
    },
    {
      iconSrc: "/assets/stock-img/slot_game_development_process_img_04.webp",
      titleText: "Slot Game Design Creation",
    },
    {
      iconSrc: "/assets/stock-img/slot_game_development_process_img_05.webp",
      titleText: "Full Stack Slot Game Development",
    },
    {
      iconSrc: "/assets/stock-img/slot_game_development_process_img_06.webp",
      titleText: "Customizations & Integrations",
    },
    {
      iconSrc: "/assets/stock-img/slot_game_development_process_img_07.webp",
      titleText: "Quality & Performance Verification",
    },
    {
      iconSrc: "/assets/stock-img/slot_game_development_process_img_08.webp",
      titleText: "Execution",
    },
    {
      iconSrc: "/assets/stock-img/slot_game_development_process_img_09.webp",
      titleText: "Post-Execution Services",
    },
  ],
};
